import { render, staticRenderFns } from "./recurrencesDestinations.vue?vue&type=template&id=fdd94ce2&"
import script from "./recurrencesDestinations.vue?vue&type=script&lang=ts&"
export * from "./recurrencesDestinations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports